export default __webpack_public_path__ + "static/media/winner_12.beba66d8.jpg";